<template>
  <div class="filter-news-feed">
    <SSelectMaterial
      :options="optionsCategory"
      v-model="category"
      selectLabel="Category"
      selectFor="category"
      class="select-component"
      @md-selected="setFilter('category')"
      dropDownClass="category"
    />
    <SSelectMaterial
      :options="optionsCondition"
      v-model="condition"
      selectLabel="Item condition"
      selectFor="condition"
      class="select-component select-item-condition"
      extraClass="itemConditionDrop"
      @md-selected="setFilter('condition')"
      dropDownClass="condition"
    />
    <SSelectMaterial
      :options="optionsType"
      v-model="trade"
      selectLabel="Trade type"
      selectFor="trade"
      class="select-component"
      @md-selected="setFilter('trade')"
      dropDownClass="trade"
    />
  </div>
</template>

<script>
import SSelectMaterial from "@/material-components/molecules/SSelectMaterial.vue";
export default {
  name: "SFilterNewsFeed",
  components: {
    SSelectMaterial,
  },
  data() {
    return {
      optionsCategory: [
        { value: "", label: "Category" },
        { value: 8, label: "Books" },
        { value: 5, label: "Auto" },
        { value: 3, label: "Clothing" },
        { value: 2, label: "Electronics" },
        { value: 9, label: "Family" },
        { value: 10, label: "Games" },
        { value: 1, label: "Household" },
        { value: 4, label: "Music" },
        { value: 11, label: "Sports" },
        { value: 12, label: "Tools" },
        { value: 6, label: "Video" },
        { value: 7, label: "Other" },
      ],
      optionsType: [
        { value: "", label: "Trade type" },
        { value: 1, label: "Give" },
        { value: 2, label: "Receive" },
        { value: 3, label: "Lend" },
        { value: 4, label: "Borrow" },
      ],
      optionsCondition: [
        { value: "", label: "Item condition" },
        { value: 1, label: "New" },
        { value: 2, label: "Like new" },
        { value: 3, label: "Used" },
        { value: 4, label: "Worn" },
      ],
      category: "",
      condition: "",
      trade: "",
    };
  },
  methods: {
    setFilter(filter) {
      switch (filter) {
        case "category":
          this.$emit("filterCategory", this.category);
          break;
        case "condition":
          this.$emit("filterCondition", this.condition);
          break;
        case "trade":
          this.$emit("filterTrade", this.trade);
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-news-feed {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  padding-left: 12px;
}
.select-component {
  margin-right: 1rem;
  width: 125px;
}
@media screen and (max-width: 495px) {
  .select-component {
    margin-right: 0.3rem;
  }
}
.select-item-condition {
  width: 160px;
}
@media screen and (max-width: 735px) {
  .filter-news-feed {
    justify-content: center;
  }
}
@media screen and (min-width: 736px) and (max-width: 960px) {
  .filter-news-feed {
    margin-left: 8px;
  }
}
@media screen and (min-width: 1081px) {
  .filter-news-feed {
    margin-left: 0px;
  }
}
</style>
